import { stringMasterAchievement } from './helpers';

export default stringMasterAchievement(2, 'B', 24);
